import React, { useState } from "react";
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import axios from "axios";
import { baseUrl, ROUTE_BASE_URL } from "../../api/common";

export default function ForgotPassword({}) {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const sendPassword = async () => {
    if (!email) {
      showToast("Email cannot be empty", "error");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/adminforgotpassword`,
        {
          email: email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      
      if (response.data.status) {
        showToast(response.data.message, "success");
        setEmail("");
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      showToast("Please try again", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  // JSX Methods for UI Components
  const renderLogo = () => {
    return (
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <Link to={`${ROUTE_BASE_URL}/login`}>
          <img
            src={logo || "/placeholder.svg"}
            width="80"
            height="80"
            alt="AMASI Logo"
            style={{  
              cursor: 'pointer',
              transition: 'opacity 0.2s ease-in-out'
            }}
            onMouseOver={(e) => {
              e.target.style.opacity = '0.8';
            }}
            onMouseOut={(e) => {
              e.target.style.opacity = '1';
            }}
          />
        </Link>
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1 style={{ 
          fontSize: '28px', 
          fontWeight: 'bold', 
          color: '#1a1a1a', 
          marginBottom: '12px',
          margin: '0 0 12px 0'
        }}>
          Forgot your Email?
        </h1>
        <p style={{ 
          color: '#666666', 
          fontSize: '14px',
          lineHeight: '1.5',
          margin: '0'
        }}>
          Enter your email address and we'll send you instructions to reset your password
        </p>
      </div>
    );
  };

  const renderEmailInput = () => {
    return (
      <div style={{ marginBottom: '24px' }}>
        <label style={{ 
          display: 'block',
          fontSize: '14px',
          fontWeight: '500',
          color: '#374151',
          marginBottom: '6px'
        }}>
          Email <span style={{ color: '#ef4444' }}>*</span>
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your Email"
          style={{
            width: '100%',
            padding: '12px 16px',
            border: '2px solid #d1d5db',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none',
            transition: 'border-color 0.2s ease-in-out'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#4285f4';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#d1d5db';
          }}
          disabled={isSubmitting}
        />
      </div>
    );
  };

  const renderSubmitButton = () => {
    const isDisabled = isSubmitting || !email;
    
    return (
      <button
        onClick={sendPassword}
        disabled={isDisabled}
        style={{
          width: '100%',
          padding: '12px 16px',
          borderRadius: '8px',
          fontWeight: '500',
          fontSize: '16px',
          border: 'none',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          backgroundColor: isDisabled ? '#e5e7eb' : '#4285f4',
          color: isDisabled ? '#9ca3af' : '#ffffff',
          transition: 'all 0.2s ease-in-out',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '24px'
        }}
        onMouseOver={(e) => {
          if (!isDisabled) {
            e.target.style.backgroundColor = '#3367d6';
          }
        }}
        onMouseOut={(e) => {
          if (!isDisabled) {
            e.target.style.backgroundColor = '#4285f4';
          }
        }}
      >
        {isSubmitting ? (
          <>
            <span style={{
              width: '16px',
              height: '16px',
              border: '2px solid #ffffff',
              borderTop: '2px solid transparent',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              marginRight: '8px'
            }}></span>
            Sending...
          </>
        ) : (
          "Send Reset Instructions"
        )}
      </button>
    );
  };

  const renderBackToLogin = () => {
    return (
      <div style={{ textAlign: 'center' }}>
        <p style={{ 
          fontSize: '14px', 
          color: '#666666',
          margin: '0'
        }}>
          Remember your password?{' '}
          <Link 
            to={`${ROUTE_BASE_URL}/login`}
            style={{
              color: '#4285f4',
              textDecoration: 'none',
              fontWeight: '500'
            }}
            onMouseOver={(e) => {
              e.target.style.textDecoration = 'underline';
            }}
            onMouseOut={(e) => {
              e.target.style.textDecoration = 'none';
            }}
          >
            Back to Login
          </Link>
        </p>
      </div>
    );
  };

  const renderSuccessMessage = () => {
    return (
      <div style={{
        backgroundColor: '#f0f9ff',
        border: '1px solid #bae6fd',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '24px',
        textAlign: 'center'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: '#4285f4',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 12px auto'
        }}>
          <span style={{ color: '#ffffff', fontSize: '24px' }}>✓</span>
        </div>
        <h3 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#1a1a1a',
          marginBottom: '8px',
          margin: '0 0 8px 0'
        }}>
          Check your email
        </h3>
        <p style={{
          fontSize: '14px',
          color: '#666666',
          margin: '0'
        }}>
          We've sent password reset instructions to your email address
        </p>
      </div>
    );
  };

  const renderMainContent = () => {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#f9fafb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px'
      }}>
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
          padding: '20px',
          width: '100%',
          maxWidth: '500px'
        }}>
          {renderLogo()}
          {renderHeader()}
          {renderEmailInput()}
          {renderSubmitButton()}
          {renderBackToLogin()}
        </div>
        
        {/* Add CSS animation for spinner */}
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  };

  // Main Render Method
  return (
    <>
      <ToastMessage />
      {renderMainContent()}
    </>
  );
}
